module.exports = new __parcel__URL__("your_squad_text.6aa8afb8.png").toString();